module.exports = "<div class=\"email-sub__message <%=statusClass%>\" role=\"alert\" aria-live=\"assertive\">\n    <%=submissionIcon%>\n    <h3 class=\"email-sub__message__headline\"><%=submissionHeadline%></h3>\n    <p class=\"email-sub__message__description\"><%=submissionMessage%></p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./static/src/javascripts/projects/common/views/email/submissionResponse.html
// module id = 669
// module chunks = 5